import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('../views/Business.vue')
  },
  {
    path: '/business/:id',
    name: 'BusinessDetail',
    component: () => import('../views/BusinessDetail.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue')
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('../views/CaseDetail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/team',
    name: 'Team',
    component: () => import('../views/Team.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/join-us',
    name: 'JoinUs',
    component: () => import('../views/JoinUs.vue')
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../views/Partner.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/Login.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/admin/Admin.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('../views/admin/Dashboard.vue')
      },
      {
        path: 'banner',
        component: () => import('../views/admin/Banner.vue')
      },
      {
        path: 'business',
        component: () => import('../views/admin/BusinessManage.vue')
      },
      {
        path: 'cases',
        component: () => import('../views/admin/CasesManage.vue')
      },
      {
        path: 'news',
        component: () => import('../views/admin/NewsManage.vue')
      },
      {
        path: 'team',
        component: () => import('../views/admin/TeamManage.vue')
      },
      {
        path: 'message',
        component: () => import('../views/admin/MessageManage.vue')
      },
      {
        path: 'recruitment',
        component: () => import('../views/admin/RecruitmentManage.vue')
      },
      {
        path: 'recruitment-concept',
        component: () => import('../views/admin/RecruitmentConceptManage.vue')
      },
      {
        path: 'partner',
        component: () => import('../views/admin/PartnerManage.vue')
      },
      {
        path: 'profile',
        component: () => import('../views/admin/Profile.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      const { authApi } = await import('../api')
      const res = await authApi.checkLogin()
      if (res.code === 200 && res.data && res.data.isLogin) {
        // 已登录，允许访问
        next()
      } else {
        // 未登录，跳转到登录页
        next({
          path: '/admin/login',
          query: { redirect: to.fullPath }
        })
      }
    } catch (error) {
      console.error('检查登录状态失败:', error)
      next({
        path: '/admin/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    // 不需要登录，直接访问
    next()
  }
})

export default router

